export function getWeek(date: Date) {
  const MondayofWeekForDate = getMondayOfWeekForDate(date);

  const week: Date[] = [];
  for (let i = 0; i < 7; i++) {
    week.push(
      new Date(MondayofWeekForDate.getTime() + i * 24 * 60 * 60 * 1000),
    );
  }
  return week;
}

export function getMondayOfWeekForDate(date: Date): Date {
  const monday = new Date(date);
  let weekDay = date.getDay();
  if (weekDay === 0) {
    weekDay = 7;
  }
  monday.setDate(date.getDate() - (weekDay - 1));
  return monday;
}
